<template>
  <standard-layout title="Tournaments">
    <v-container fluid>
      <v-list v-if="allTournaments.length > 0">
        <v-list-item
          v-for="tournament in allTournaments"
          :key="tournament.id"
          density="default"
          class="mb-1"
          :to="{ name: 'tournament', params: { id: tournament.id } }"
          :title="tournament.title"
          :subtitle="`${(tournament.players || []).length} player${tournament.players.length === 1 ? '' : 's'}`"
          prepend-icon="mdi-trophy-outline"
        />
      </v-list>

      <div v-else class="text-center">
        <p class="text-body-1 mb-4">
          No tournaments yet.
        </p>
        <v-btn
          color="primary"
          prepend-icon="mdi-plus"
          @click="$router.push({ name: 'tournamentNew' })"
        >
          Create Tournament
        </v-btn>
      </div>
    </v-container>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/components/standard-layout.vue";
import { db, dbFns } from "@/db";
import getModel from "@/models/get-model";

export default {
  components: {
    StandardLayout
  },
  inject: ["$store"],
  data () {
    return {
      allTournaments: [],
      tournamentModels: {},
      playersSnapshotUnsubscribe: null
    };
  },
  created () {
    this.loadAllTournaments();
  },
  beforeUnmount () {
    if (this.playersSnapshotUnsubscribe) this.playersSnapshotUnsubscribe();
    Object.values(this.tournamentModels).forEach(model => model.unsubscribe());
  },
  methods: {
    loadAllTournaments () {
      const { collection, query, where, onSnapshot } = dbFns;
      const q = query(
        collection(db, "players"),
        where("playerUserId", "==", this.$store.user.id)
      );
      this.playersSnapshotUnsubscribe = onSnapshot(q, (snapshot) => {
        const promises = [];
        snapshot.docs.forEach(d => {
          const data = d.data();
          if (this.tournamentModels[data.tournamentId]) return;
          const TournamentModel = getModel("tournament");
          const tournament = new TournamentModel({
            propsData: {
              docRef: dbFns.doc(db, "tournaments", data.tournamentId),
              user: { id: data.userId },
              parent: { id: data.userId },
              startSnapshot: true,
              docType: "tournament"
            }
          });
          this.tournamentModels[data.tournamentId] = tournament;
          promises.push(Promise.all([tournament.promiseOnSnapshot, ...tournament.prereqPromises]));
        });
        Promise.all(promises).then(() => {
          this.allTournaments = Object.values(this.tournamentModels)
            .slice()
            .sort((a, b) => b.createdAt.toDate() - a.createdAt.toDate());
        }).catch((error) => {
          console.error({ error });
        });
      }, (error) => {
        console.error({ error });
      });
    }
  }
};
</script>
